export function matchesSimilaritySearch(match, search) {
    const term = search?.trim().toLowerCase()
    if (!term) return true
    const title = match?.title?.toLowerCase() ?? ""
    const scheduleTitle = match?.scheduleTitle?.toLowerCase() ?? ""
    const scheduleCode = match?.scheduleCode?.toLowerCase() ?? ""
    return title.includes(term) || scheduleTitle.includes(term) || scheduleCode.includes(term)
}
